import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'
import { LOCALE } from '../../../constants/activity-constants'
import './home-prizes.scss'

const HomePrizes = ({ isMobile }: { isMobile: boolean | null }) => {
  if (LOCALE === 'es-EC') {
    return (
      <div className="f-home-prize_wrapper">
        <div className="f-home-prize_prizes">
          <StaticImage
            src="../../../assets/images/home/prizes/ec/prize_iphone_ec.png"
            alt="regalo iphones"
            placeholder="blurred"
            className="f-home-prize_prizes-image_phone-EC"
            width={270}
          />
          <div className="f-home-prize_prizes__description">
            <p>
              Del top 1 al 2 ganarás{' '}
              <span>1 Iphone 14 de 128GB + 1 canasta de productos</span>
            </p>
          </div>
          <div className="f-home-prize_prizes__tag">
            {productImage}
            <span>*Imagen de referencia</span>
          </div>
        </div>
        <div
          style={isMobile ? undefined : { marginLeft: -15 }}
          className="f-home-prize_prizes --watch"
        >
          <StaticImage
            src="../../../assets/images/home/prizes/ec/prize_watch_ec.png"
            alt="regalo reloj inteligente"
            placeholder="blurred"
            className="f-home-prize_prizes-image_watch-EC"
            width={160}
          />
          <div className="f-home-prize_prizes__description --watch">
            <p>
              Del top 5 al 10 ganarás{' '}
              <span>1 reloj Smart Watch + 1 canasta de productos</span>
            </p>
          </div>
          <div
            style={{ right: -50, bottom: 50 }}
            className="f-home-prize_prizes__tag --watch"
          >
            {productImage}
            <span>*Imagen de referencia</span>
          </div>
        </div>
        <div
          style={isMobile ? undefined : { marginTop: -30 }}
          className="f-home-prize_prizes --headphones"
        >
          <StaticImage
            src="../../../assets/images/home/prizes/ec/prize_headphones_ec.png"
            alt="regalo reloj inteligente"
            placeholder="blurred"
            className="f-home-prize_prizes-image_headphones-EC"
            width={140}
          />
          <div className="f-home-prize_prizes__description --headphones">
            <p>
              Del top 3 al 4 ganarás{' '}
              <span>
                1 Auriculares Beats Solo3 Wireless + 1 canasta de productos
              </span>
            </p>
          </div>
          <div className="f-home-prize_prizes__tag --headphones">
            {productImage}
            <span>*Imagen de referencia</span>
          </div>
        </div>
      </div>
    )
  } else if (LOCALE === 'es-PE') {
    return (
      <div className="f-home-prize_wrapper">
        <div
          style={isMobile ? undefined : { marginLeft: 35 }}
          className="f-home-prize_prizes"
        >
          <StaticImage
            src="../../../assets/images/home/prizes/pe/prize_phone_pe.png"
            alt="regalo iphones"
            placeholder="blurred"
            className="f-home-prize_prizes-image_phone-PE"
            width={240}
          />
          <div className="f-home-prize_prizes__description  --phone-PE">
            <p>
              Puesto 1: <br />
              <span>Ganarás 1 Iphone 14 rojo 128BG</span>
              <br />
              *Imagen de referencia
            </p>
          </div>
        </div>
        <div
          style={isMobile ? undefined : { marginLeft: -35 }}
          className="f-home-prize_prizes --watch"
        >
          <StaticImage
            src="../../../assets/images/home/prizes/pe/prize_tab_pe.png"
            alt="regalo reloj inteligente"
            placeholder="blurred"
            className="f-home-prize_prizes-image_tab_PE"
            width={200}
          />
          <div className="f-home-prize_prizes__description --tab">
            <p>
              Puesto 2:
              <br />
              <span>Ganarás 1 tablet GALAXY A9</span>
              <br />
              *Imagen de referencia
            </p>
          </div>
        </div>
        <div
          style={isMobile ? undefined : { marginLeft: 10, marginTop: -40 }}
          className="f-home-prize_prizes"
        >
          <StaticImage
            src="../../../assets/images/home/prizes/pe/prize_jbl_pe.png"
            alt="regalo reloj inteligente"
            placeholder="blurred"
            className="f-home-prize_prizes-image_jbl-PE"
            width={220}
          />
          <div className="f-home-prize_prizes__description --jbl">
            <p>
              Puesto 3:
              <br />
              <span>Ganarás 1 parlante JBL SPEAKER FLIP 6</span>
              <br />
              *Imagen de referencia
            </p>
          </div>
        </div>
        <div
          style={isMobile ? undefined : { marginLeft: -35, marginTop: -40 }}
          className="f-home-prize_prizes --watch"
        >
          <StaticImage
            src="../../../assets/images/home/prizes/pe/prize_watch_pe.png"
            alt="regalo reloj inteligente"
            placeholder="blurred"
            className="f-home-prize_prizes-image_watch-PE"
            width={190}
          />
          <div className="f-home-prize_prizes__description --watch-PE">
            <p>
              Del top 4 al 10: <br />
              <span>
                Ganarán 1 SMARTWATCH 4 OBSIDIAN BLACK + kit de productos
                Nosotras®
              </span>
            </p>
          </div>
          <div
            style={{ right: -70, bottom: 50 }}
            className="f-home-prize_prizes__tag --watch-PE"
          >
            {productImage}
            <span>*Imagen de referencia</span>
          </div>
        </div>
      </div>
    )
  }
  return (
    <div className="f-home-prize_wrapper">
      <div className="f-home-prize_prizes">
        <StaticImage
          src="../../../assets/images/home/prizes/co/prize_iphones_co.png"
          alt="regalo iphones"
          placeholder="blurred"
          className="f-home-prize_prizes-image_phone"
          width={270}
        />
        <div className="f-home-prize_prizes__description">
          <p>
            Del top 1 al 3 ganarás <span>1 Iphone 14 + 1 kit de productos</span>
          </p>
        </div>
        <div className="f-home-prize_prizes__tag">
          {productImage}
          <span>*Imagen de referencia</span>
        </div>
      </div>
      <div className="f-home-prize_prizes --watch">
        <StaticImage
          src="../../../assets/images/home/prizes/co/prize_watch_co.png"
          alt="regalo reloj inteligente"
          placeholder="blurred"
          className="f-home-prize_prizes-image_watch"
          width={140}
        />
        <div className="f-home-prize_prizes__description --watch">
          <p>
            Del top 4 al 10 ganarás <span>1 reloj Smart Watch</span>
            <span> + 1 kit de productos</span>
          </p>
        </div>
        <div className="f-home-prize_prizes__tag --watch">
          {productImage}
          <span>*Imagen de referencia</span>
        </div>
      </div>
    </div>
  )
}

export default HomePrizes

const productImage = {
  'es-CO': (
    <StaticImage
      src="../../../assets/images/home/prizes/co/prize_nosotras_co.png"
      alt="regalo nosotras"
      className="f-home-prize_prizes__tag-image"
      placeholder="blurred"
      width={90}
    />
  ),
  'es-EC': (
    <StaticImage
      src="../../../assets/images/home/prizes/ec/prize_nosotras_ec.png"
      alt="regalo nosotras"
      className="f-home-prize_prizes__tag-image"
      placeholder="blurred"
      width={90}
    />
  ),
  'es-PE': (
    <StaticImage
      src="../../../assets/images/home/prizes/pe/prize_nosotras_pe.png"
      alt="regalo nosotras"
      className="f-home-prize_prizes__tag-image"
      placeholder="blurred"
      width={90}
    />
  ),
}[LOCALE]
